<script setup lang="ts">
import { PhPlayCircle } from '@phosphor-icons/vue';
import LazyImage from '~/components/LazyImage.vue';
import { MediaType } from './types';

interface Props {
	src: string;
	alt: string;
	isActive: boolean;
	type: MediaType;
	isStyle?: boolean;
}
defineProps<Props>();
</script>

<template>
	<div class="rounded-xs aspect-[5/7] relative overflow-hidden">
		<LazyImage
			:class="isActive || isStyle ? 'opacity-100' : 'opacity-40'"
			:src="src"
			:alt="alt"
			width="90"
			loading="lazy"
		/>
		<div
			v-if="type === MediaType.VIDEO"
			class="absolute inset-0 flex items-center justify-center"
		>
			<div
				:class="[isStyle ? 'bg-transparent' : 'bg-white/80 backdrop-blur-xs']"
				class="w-full p-sm flex flex-col items-center"
			>
				<PhPlayCircle
					:size="isStyle ? 40 : 30"
					:color="isStyle ? '#ffffff' : '#424242'"
				/>
			</div>
		</div>
	</div>
</template>
